// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__1Ypwe","rootSuccess":"CompleteLink_rootSuccess__3AjGI","rootFailure":"CompleteLink_rootFailure__37NQI","isDisabled":"CompleteLink_isDisabled__3Q-xa"};